import {useContext} from "react"
import AuthContext from "./AuthProvider.js"

function useAuth() {
    return useContext(AuthContext)
}

export default useAuth